import React from "react";
import { useSelector } from "react-redux";
import ActiveFilter from "../../components/ActiveFilter/ActiveFilter";
import hash from "../../Utils/hash";
import styles from "./ActiveFiltersContainer.module.scss";
import ResetSearchButton from "../../components/ResetSearchButton/ResetSearchButton";

const ActiveFiltersContainer = (props) => {
  const newFilterState = useSelector((state) => state.newFilterReducer);
  const activeFilters = { ...newFilterState.activeFilters };

  // KI-20
  if (activeFilters.type) {
    delete activeFilters.type;
  }

  let activeFiltersR = [];

  // Special case: If both `query_fields` and `query_value` have been set to the active filters(**) they should be
  // treated as one ActiveFilter.
  // Example url: http://localhost:3000/#query_fields=%22sm_organisasjon_evu%22&query_value=1
  //
  // **: This can happen ONLY with a direct link to a specific search, it's not possible to be caused within the widget itself
  if (
    activeFilters.query_value !== undefined &&
    activeFilters.query_fields !== undefined
  ) {
    activeFiltersR.push(
      <ActiveFilter
        key="composite-query_value-query_fields"
        facetName="composite-query_value-query_fields"
        value="Anvendt filter"
        isMultivalue={false}
        isComposite={true}
      />,
    );
    delete activeFilters.query_value;
    delete activeFilters.query_fields;
  }

  for (const [key, item] of Object.entries(activeFilters)) {
    if (Array.isArray(item)) {
      item.forEach((element) => {
        const myKey = key + "-" + hash(element.value);
        activeFiltersR.push(
          <ActiveFilter
            key={myKey}
            facetName={key}
            value={element.value}
            isMultivalue={true}
          />,
        );
      });
    } else {
      const myKey = key + "-" + hash(item.value);
      activeFiltersR.push(
        <ActiveFilter
          key={myKey}
          facetName={key}
          value={item.value}
          isMultivalue={false}
        />,
      );
    }
  }

  return (
    <div className={styles.wrapper} id="filtersWrapper">
      {activeFiltersR.length > 1 && <ResetSearchButton />}

      {activeFiltersR}
    </div>
  );
};

export default ActiveFiltersContainer;
